import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import { drapcodeIcon, iconForField } from '../../../common/custom/icon-library';
import CustomLoader from '../../common/CustomLoader';
import PWAImageUploadField from './PWAImageUploadField';
import CustomInputWithIcon from '../../../common/ui/CustomInputWithIcon';
import TooltipInfo from '../../../common/docs/TooltipInfo';
import { description } from '../../../common/utils/event_constants';

export default class PWAConfigForm extends Component {
  static propTypes = {
    handlePWAConfigSubmit: PropTypes.func.isRequired,
  };
  state = {
    enablePwaConfig: false,
  };

  clearForm = () => {
    this.setState({
      schema: {},
      enablePwaConfig: false,
    });
  };

  updateEnablePwaConfig = () => {
    this.setState({
      enablePwaConfig: true,
    });
  };

  validateName = (value) => {
    if (value && value.length > 50) {
      this.setState({ enablePwaConfig: false });
      return 'Name cannot have more than 50 characters.';
    }

    this.setState({ enablePwaConfig: true });
  };

  validateShortName = (value) => {
    if (value && value.length > 50) {
      this.setState({ enablePwaConfig: false });
      return 'Short Name cannot have more than 30 characters.';
    }

    this.setState({ enablePwaConfig: true });
  };

  createSchemaPWAConfig = () => {
    const { pwaConfig } = this.props;
    if (pwaConfig) {
      return {
        name: pwaConfig.name,
        shortName: pwaConfig.shortName,
        description: pwaConfig.description,
        icon: pwaConfig.icon,
      };
    } else {
      return {};
    }
  };

  handlePWAConfigSubmit = (values) => {
    const { pwaConfig, version } = this.props;
    this.props.handlePWAConfigSubmit(
      {
        name: values.name,
        shortName: values.shortName,
        description: values.description,
        icon: values.icon,
      },
      pwaConfig ? false : true,
    );
  };
  handlePWAConfigDelete = () => {
    this.clearForm();
    this.props.handlePWAConfigDelete();
  };

  render() {
    const { showPWAConfigLoader, pwaConfig, projectId, deleteFlag, plugins, s3Url } = this.props;
    return (
      <>
        <Formik
          enableReinitialize={true}
          initialValues={this.createSchemaPWAConfig()}
          onSubmit={(values, { setSubmitting, resetForm }) => {
            this.handlePWAConfigSubmit(values);
            setSubmitting(false);
          }}
        >
          {({ values, isSubmitting, setFieldValue, setSubmitting, errors }) => {
            return (
              <Form className="form-horizontal">
                <div className="row mx-auto">
                  <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                    <CustomInputWithIcon title="Name" icon="text" required={true}>
                      <Field
                        name="name"
                        className="form-control form-control-sm"
                        placeholder="Enter PWA App Name"
                        validate={this.validateName}
                      />
                      <ErrorMessage name="name">
                        {(msg) => <p className="text-error">{msg}</p>}
                      </ErrorMessage>
                    </CustomInputWithIcon>
                  </div>
                  <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                    <CustomInputWithIcon title="Short Name" icon="text" required={true}>
                      <Field
                        name="shortName"
                        className="form-control form-control-sm"
                        placeholder="Enter PWA App Short Name"
                        validate={this.validateShortName}
                      />
                      <ErrorMessage name="shortName">
                        {(msg) => <p className="text-error">{msg}</p>}
                      </ErrorMessage>
                    </CustomInputWithIcon>
                  </div>
                  <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                    <CustomInputWithIcon title="Description" icon="text" required={true}>
                      <Field
                        name="description"
                        className="form-control form-control-sm"
                        placeholder="Enter PWA App Description"
                      />
                      <ErrorMessage name="description">
                        {(msg) => <p className="text-error">{msg}</p>}
                      </ErrorMessage>
                    </CustomInputWithIcon>
                  </div>
                  <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                    <PWAImageUploadField
                      field={{
                        fieldName: 'icon',
                        required: false,
                        fieldTitle: { en: 'PWA Icon' },
                      }}
                      setFieldValue={setFieldValue}
                      folderName="project-pwa-config"
                      values={values}
                      projectId={projectId}
                      setSubmitting={setSubmitting}
                      s3Url={s3Url}
                      plugins={plugins}
                      updateEnablePwaConfig={this.updateEnablePwaConfig}
                    />
                  </div>
                  <div className="col-md-12 col-lg-12 text-right">
                    {!pwaConfig ? (
                      <button
                        type={`${this.state.enablePwaConfig ? 'submit' : 'button'}`}
                        className={`btn btn-md ${
                          this.state.enablePwaConfig ? 'btn-theme-submit' : 'btn-default disabled'
                        }`}
                        disabled={isSubmitting && showPWAConfigLoader ? 'disabled' : ''}
                        title="Add PWA Configuration"
                      >
                        <i className={`wb ${drapcodeIcon('create')}`}></i>&nbsp; Create&nbsp;
                        <CustomLoader loading={showPWAConfigLoader} />
                      </button>
                    ) : (
                      <>
                        <button
                          className="btn btn-theme-delete btn-md"
                          style={{ cursor: deleteFlag ? 'pointer' : 'not-allowed' }}
                          onClick={() => (deleteFlag ? this.handlePWAConfigDelete() : undefined)}
                          title={`Delete PWA Config`}
                          type="button"
                        >
                          <span>
                            <i className={`wb ${drapcodeIcon('delete')}`}></i>&nbsp;Delete
                          </span>
                          {deleteFlag ? null : (
                            <>
                              &nbsp;
                              <TooltipInfo
                                title={description}
                                headerText={`Permission Disabled!`}
                                showHeader={true}
                                showArrow={true}
                              />
                            </>
                          )}
                        </button>
                        &nbsp;
                        <button
                          type="submit"
                          className="btn btn-theme-submit btn-md"
                          disabled={isSubmitting && showPWAConfigLoader ? 'disabled' : ''}
                          title="Update PWA Configuration"
                        >
                          <i className={`wb ${drapcodeIcon('update')}`}></i>&nbsp;Update
                          <CustomLoader loading={showPWAConfigLoader} />
                        </button>
                      </>
                    )}
                  </div>
                </div>
              </Form>
            );
          }}
        </Formik>
      </>
    );
  }
}
